module.exports = __webpack_public_path__ + "media/images/plan_drawing-32c4187a9575abb6714214c7108f1afd.png";